<script lang="ts">import assets from "../assets";
import { cardsData } from "../data";
import Vip from "../icons/vip.png";
import { getVerbiageKey } from "../utils";
import { Button } from "@infinitro/button";
import { stateUi } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { ModalDialog, pushModal } from "@infinitro/global";
import { InfoCard } from "@infinitro/info-card";
import { Text } from "@infinitro/text";
const CardsLeft = assets.cardsLeft;
const CardsRight = assets.cardsRight;
const Chests = assets.chests;
</script>

<div
	class="vip-club-container"
	class:vip-club-container--compact={$stateUi.vip?.useCompactClubOverviewSectionHeights}
>
	<div class="vip-club-badge">
		<img src={Vip} alt={$t(Verbiage.vip_icons_alt, 'alts')} />
		<Text type="body" bodySize="small">{$t(Verbiage[getVerbiageKey('vip_club_text')])}</Text>
	</div>
	<Text type="title" titleSize="h3" textAlign="center"
		>{$t(Verbiage[getVerbiageKey('like_what_you_see_text')])}
		<span class="highlight-text"
			>{$t(Verbiage[getVerbiageKey('join_vip_club_call_to_action')])}</span
		></Text
	>
	<div class="vip-club-content">
		{#if CardsLeft && CardsRight && Chests}
			<img src={CardsLeft} alt={$t(Verbiage.cards_left_alt, 'alts')} class="cards-left" />
			<img src={Chests} alt={$t(Verbiage.chests_alt, 'alts')} class="chests" />
			<img src={CardsRight} alt={$t(Verbiage.cards_right_alt, 'alts')} class="cards-right" />
		{/if}
		<div class="vip-club-card">
			<InfoCard width="70%" fullWidthMobile={true}>
				<div class="card-align">
					<div class="max-w-mobile">
						<Text
							type="subtitle"
							subtitleSize="large"
							textAlign="center"
							customStyle="line-height: 168%;"
						>
							{$t(Verbiage[getVerbiageKey('sign_up_today_call_to_action')])}
						</Text>
					</div>
					<Button
						text={$t(Verbiage[getVerbiageKey('sign_up_text')])}
						styleCustom="margin-top: 1rem;"
						fullWidth
						onClick={() => pushModal(ModalDialog.Auth, { tab: 'signup' })}
					/>
				</div>
			</InfoCard>
		</div>
	</div>
</div>

<style>
	.vip-club-container {

		display: flex;

		min-height: 600px;

		width: 100%;

		flex-direction: column;

		align-items: center;

		gap: 0.75rem
}

	.vip-club-container--compact {

		min-height: 400px
}

	.vip-club-badge {

		display: flex;

		align-items: center;

		justify-content: center;

		gap: 0.25rem;

		border-radius: 9999px;

		padding-left: 1rem;

		padding-right: 1rem;

		padding-top: 0.25rem;

		padding-bottom: 0.25rem;

		background: var(--gradient-main)
}

	.highlight-text {

		color: var(--color-primary-500)
}

	.vip-club-content {

		position: relative;

		z-index: 40;

		display: flex;

		min-height: 350px;

		width: 100%;

		align-items: center;

		justify-content: space-between;

		gap: 0.75rem
}
	@media (min-width: 768px) {
		.vip-club-content {

				top: 0px
		}
	}

	.vip-club-card {

		position: absolute;

		top: 50%;

		width: 100%;

		--tw-translate-y: -50%;

		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}
	@media (min-width: 768px) {
		.vip-club-card {

				left: 50%;

				width: auto;

				--tw-translate-x: -50%;

				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
		}
	}
	@media (min-width: 1024px) {
		.vip-club-card {

				--tw-translate-x: -33.333333%;

				transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
		}
	}

	.cards-left {

		position: absolute;

		top: -210px;

		left: -1.25rem;

		z-index: 20;

		display: none;

		width: 25%
}
	@media (min-width: 768px) {
		.cards-left {

				position: static;

				display: block;

				width: 25%
		}
	}
	@media (min-width: 1280px) {
		.cards-left {

				width: 33.333333%
		}
	}

	.cards-right {

		position: absolute;

		right: -1.25rem;

		top: 5rem;

		z-index: 20;

		display: none;

		width: 25%
}
	@media (min-width: 768px) {
		.cards-right {

				position: static;

				display: block;

				width: 25%
		}
	}
	@media (min-width: 1280px) {
		.cards-right {

				width: 33.333333%
		}
	}

	.chests {

		position: absolute;

		width: 100%
}
	@media (min-width: 768px) {
		.chests {

				position: static;

				width: auto
		}
	}

	.max-w-mobile {

		display: flex;

		max-width: 300px;

		flex-direction: column;

		align-items: center
}
	@media (min-width: 768px) {
		.max-w-mobile {

				max-width: none
		}
	}

	.card-align {

		display: flex;

		width: 100%;

		flex-direction: column;

		align-items: center
}
</style>
